package dev.danko.roblox_craft_ai.pages.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import dev.danko.roblox_craft_ai.client.RobloxCraftApiClient
import dev.danko.roblox_craft_ai.components.layouts.PageLayoutData
import dev.danko.roblox_craft_ai.state.AuthState
import dev.danko.roblox_craft_ai.state.Txt
import dev.danko.roblox_craft_ai.uikit.components.AppButton
import dev.danko.roblox_craft_ai.uikit.components.AppButtonVariant
import dev.danko.roblox_craft_ai.uikit.components.AppCard
import dev.danko.roblox_craft_ai.uikit.i18n.strings
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import kotlinx.browser.window
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.vh

private enum class VerifyState { CHECKING, SUCCESS, FAILED }

@InitRoute
@Suppress("unused")
fun initVerifyPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Txt.auth.verifyTitle))
}

@Composable
@Page("/auth/verify")
fun VerifyPage() {
    val s = strings().auth
    val palette = LocalAppTheme.current.colors
    val ctx = rememberPageContext()
    var state by remember { mutableStateOf(VerifyState.CHECKING) }
    var email by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        val token = window.location.hash.removePrefix("#").split('&')
            .firstOrNull { it.startsWith("token=") }?.removePrefix("token=").orEmpty()
        // Drop the one-time token from the address bar and history right away.
        window.history.replaceState(null, "", window.location.pathname)
        state = try {
            if (token.isBlank()) error("missing token")
            val user = RobloxCraftApiClient.verifyMagicLink(token)
            AuthState.signedIn(user)
            email = user.email
            VerifyState.SUCCESS
        } catch (_: Throwable) {
            VerifyState.FAILED
        }
        if (state == VerifyState.SUCCESS) {
            kotlinx.coroutines.delay(1500)
            ctx.router.navigateTo("/")
        }
    }

    Box(Modifier.fillMaxWidth().minHeight(70.vh).padding(1.cssRem), contentAlignment = Alignment.Center) {
        AppCard(Modifier.maxWidth(28.cssRem).width(100.percent)) {
            Column(Modifier.fillMaxWidth().gap(1.cssRem), horizontalAlignment = Alignment.CenterHorizontally) {
                SpanText(s.verifyTitle, Modifier.fontSize(1.15.cssRem).color(palette.textPrimary))
                when (state) {
                    VerifyState.CHECKING -> SpanText("⏳ ${s.verifying}", Modifier.color(palette.textSecondary))
                    VerifyState.SUCCESS -> {
                        SpanText("✅ ${s.verifySuccess(email)}", Modifier.color(palette.textPrimary))
                        AppButton(text = s.toWorkshop, onClick = { ctx.router.navigateTo("/") })
                    }
                    VerifyState.FAILED -> {
                        SpanText("⚠️ ${s.verifyFailed}", Modifier.color(palette.textPrimary))
                        AppButton(text = s.requestNewLink, onClick = { AuthState.loginDialogOpen = true })
                        AppButton(text = s.toWorkshop, onClick = { ctx.router.navigateTo("/") }, variant = AppButtonVariant.OUTLINE)
                    }
                }
            }
        }
    }
}
